import React from 'react';

import PokemonItems from '../../components/PokemonItems/PokemonItems.jsx';


const MyPokemon = (props) => {

    function releaseMyPokemon(ownedPokemonUUID) {

        console.log('releasing ' + ownedPokemonUUID);
        let [releaseTarget] = props.mySavedData.pokemonList.filter((item) => (ownedPokemonUUID === item.ownedPokemonUUID));
        let promptRelease = window.confirm(`are you sure want to release ${releaseTarget.nickname} (${releaseTarget.name})?? `);

        //prompRelease Ok or Cancel..
        if (promptRelease) {//confirmed
            alert(`${releaseTarget.nickname} (${releaseTarget.name}) is released .......... see you....... :(`);

            //save the release removal
            props.setMySavedData(
                (previousState) => {
                    return {
                        ...previousState,
                        pokemonList: previousState.pokemonList.filter((item) => item.ownedPokemonUUID !== releaseTarget.ownedPokemonUUID)

                    }
                }
            )

        } else {
            alert(`Well... you decide to let ${releaseTarget.nickname} (${releaseTarget.name}) stay with us a little longer!!...`);
        }
    }

    return (
        <div>
            <h1>My Pokemon List: </h1>

            {/* Reuse Pokemon List component */}

            <PokemonItems pokemonList={props.mySavedData} releaseMyPokemon={releaseMyPokemon} />

        </div>
    )
}

MyPokemon.propTypes = {

}

export default MyPokemon;
